var parameterInsert={
    IdUser:'',
    NameLink:'',
    UrlLink:'', 
    User:'',
    IP:''
} 
var parameterUpdate={
    IdLinkURL:'',
    NameLink:'',
    UrlLink:'', 
    Active:'1', 
    User:'',
    IP:''
} 
var parameterView={ 
    IdUser:'' 
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}